import React, {useEffect, useState} from 'react'
import Nav from "react-bootstrap/Nav";
import {HeadlineModal} from "../../../ui/tools/HeadlineModal";
import {ReminderModal} from "../../../ui/tools/ReminderModal";
import {CnATeamCard} from "./panels/team/CnATeamCard";
import {useDispatch, useSelector} from "react-redux";
import {Loading} from "../../../ui/loading/Loading";
import {zynity_api} from "../../../../config/external-routes";
import {CnAHeader} from "./cna_header/CnAHeader";
import {TeamPanel} from "./panels/team/TeamPanel";
import {MemberPanel} from "./panels/member/MemberPanel";
import {useNavigate, useParams} from "react-router-dom";
import {findDatumByDatumId, findDatumByDatumIdInAllTools} from "../../../../helpers/tools";
import {setDatumIdOpen, setDatumIdOpenData} from "../../../../store/user_organizations/teams/tools/connect_and_align";

export const CnAContainer = () => {
    const dispatch = useDispatch();
    const {organization_id, team_id} = useParams();
    const navigate = useNavigate();
    const cna = useSelector((state:any) => state.tool_cna)
    const [selectedMember, setSelectedMember] = useState('team');
    let cna_data = cna.data;

    useEffect(() => {
        if(cna?.datum_id_open != undefined && cna.datum_id_open > 0) {
            let selected_datum = findDatumByDatumIdInAllTools(cna_data, parseInt(cna.datum_id_open))
            console.log("Going to update from datum_id", cna.datum_id_open, selected_datum)
            if(selected_datum !== undefined) {
                dispatch( setDatumIdOpenData(selected_datum) );
                setSelectedMember(selected_datum.user_id)
            }
        }
    }, [cna.isLoading, cna.datum_id_open])

    if(cna.isLoading) {
        return <Loading />
    }

    if(selectedMember === 'coach_notes') {
        navigate(`/organizations/${organization_id}/teams/${team_id}/coach/notes`)
    }

    return (
        <div className='container'>
            <CnAHeader setSelectedMember={setSelectedMember} selectedMember={selectedMember} />
            {
                selectedMember === 'team' && <TeamPanel setSelectedMember={setSelectedMember} />
            }
            {
                !isNaN(+selectedMember) && <MemberPanel selectedMember={selectedMember} />
            }
        </div>
    )
}
